import type { FilterSelectOption } from '../../../../../types/table';
import type { SelectFilterControl } from './helpers';

/** Option search: the endpoint's when the control loads options with `onSearch`, else the sidebar's own. */
export const useOptionFilter = (
  searchTerms: Record<string, string>,
  setSearchTerms: React.Dispatch<React.SetStateAction<Record<string, string>>>
) => {
  const getSearchValue = (control: SelectFilterControl) =>
    control.load?.onSearch ? (control.load.search ?? '') : (searchTerms[control.id] ?? '');

  const handleSearchChange = (control: SelectFilterControl, value: string) => {
    if (control.load?.onSearch) {
      control.load.onSearch(value);
    } else {
      setSearchTerms((prev) => ({
        ...prev,
        [control.id]: value
      }));
    }
  };

  const getFilteredOptions = (control: SelectFilterControl): FilterSelectOption[] => {
    const searchTerm = searchTerms[control.id] ?? '';
    if (control.load?.onSearch || !searchTerm) {
      return control.options;
    }
    return control.options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
  };

  return {
    getSearchValue,
    handleSearchChange,
    getFilteredOptions
  };
};
